import React from "react";
import {
  FaBookOpen,
  FaLaptopCode,
  FaChalkboardTeacher,
  FaUsers,
  FaGlobe,
  FaRunning,
  FaLeaf,
  FaHandsHelping,
} from "react-icons/fa";
import "./HighSchool.css";

const HighSchool = () => {
  return (
    <div className="high-school-page">
      {/* Hero Section */}
      <section className="high-section">
        <h1>
          <FaBookOpen className="icon" /> Matric & O-Levels (Grades 9–10) at Academic Group of Schools
        </h1>
        <p>
          At <strong>Academic Group of Schools (AGS)</strong>, we prepare young minds
          for a rapidly changing world. Guided by our motto,{" "}
          <strong>STEM, SKILLS, SERVICE</strong>, we nurture curiosity,
          adaptability, and innovation to help students meet the challenges and
          opportunities of modern life.
        </p>
        <p>
          As a STEM-focused institution, AGS blends science, technology,
          engineering, and mathematics into hands-on learning that sharpens
          problem-solving, analytical thinking, and creativity — preparing
          students for the careers of the future.
        </p>
        <p>
          We combine rigorous academics with strong values, shaping confident,
          capable, and responsible individuals. Beyond the classroom, our
          students engage in activities that build leadership, teamwork, and
          resilience, empowering them to make a lasting impact.
        </p>
      </section>

      {/* STEM Focus */}
      <section className="high-section">
        <h2>
          <FaLaptopCode className="icon" /> Why STEM at Academic Group of Schools ?
        </h2>
        <p>
          Our students dive into coding, programming, and circuit design while
          building real-world solutions using tools like Arduino, Bee-Bot, and
          Micro:bit. From functional robotics to AI-based projects, they develop
          future-ready skills through hands-on learning.
        </p>
        <p>
          We bring mathematical concepts to life through modelling and
          engineering challenges that encourage analytical thinking, creativity,
          and problem-solving.
        </p>
      </section>

      {/* Dual Curriculum */}
      <section className="high-section">
        <h2>
          <FaChalkboardTeacher className="icon" /> Dual Curriculum: O-Levels &
          Matriculation
        </h2>
        <p>
          AGS offers flexibility through both <strong>O-Level</strong> and{" "}
          <strong>Matriculation</strong> tracks, aligning with each student’s
          future academic and career aspirations.
        </p>
        <ul>
          <li>
            <strong>Matriculation (Grades 9–10):</strong> Robust local
            curriculum with modern electives such as Robotics, Coding, Fashion
            Design, Environmental Studies, and Physical Fitness Programs.
          </li>
          <li>
            <strong>O-Level (Grades 9–10):</strong> Prestigious Cambridge
            program, recognized globally, emphasizing creative inquiry,
            practical skills, and academic excellence.
          </li>
        </ul>
      </section>

      {/* Matriculation */}
      <section className="high-section">
        <h2>
          <FaUsers className="icon" /> Matriculation at AGS
        </h2>
        <p>
          From Pre-IX to Grade  X, our Matriculation program builds a strong
          foundation for board examinations. Students benefit from highly
          qualified teachers, a balanced curriculum, and enrichment courses that
          promote critical thinking, creativity, and leadership.
        </p>
      </section>

      {/* O-Levels */}
      <section className="high-section">
        <h2>
          <FaGlobe className="icon" /> Cambridge O-Level at AGS
        </h2>
        <p>
          Recognized worldwide, the Cambridge O-Level equips students with
          theoretical and hands-on learning experiences. Students engage in
          coding, robotics, and interdisciplinary projects while exploring a
          wide range of subjects, preparing them for higher education and
          international opportunities.
        </p>
      </section>

      {/* Extra Curricular */}
      <section className="high-section">
        <h2>
          <FaRunning className="icon" /> Extracurricular Activities
        </h2>
        <p>
          Beyond academics, students participate in after-school clubs, sports
          competitions, inter-branch and inter-school mega events, and awareness
          campaigns such as <em>Anti-Bullying Week</em>. These experiences
          foster collaboration, leadership, and resilience.
        </p>
      </section>

      {/* Community Service */}
      <section className="high-section">
        <h2>
          <FaHandsHelping className="icon" /> Community Service
        </h2>
        <p>
          Community service is integral at AGS. Students engage in projects like
          environmental conservation, hospital ward decoration, park care, and
          charity drives — nurturing empathy, responsibility, and global
          citizenship.
        </p>
      </section>

      {/* Sustainability */}
      <section className="high-section">
        <h2>
          <FaLeaf className="icon" /> Shaping Future Leaders
        </h2>
        <p>
          Whether you choose O-Levels or Matric, AGS equips students with the
          education, skills, and values needed to thrive in the 21st century.
          Join us in shaping Pakistan’s next generation of leaders.
        </p>
      </section>
    </div>
  );
};

export default HighSchool;
